import ApiService from "./apiService";
import { ANNOUNCEMENT } from "../constants/apiEndpoints";

export const getActiveAnnouncement = async () => {
  try {
    const response = await ApiService.get(
      ANNOUNCEMENT,
      {},
      {},
      "json",
      false
    );
    return response;
  } catch (error) {
    console.error("Error fetching announcement:", error);
    return null;
  }
};
